import { useState } from "react";
import { useRef } from "react";
import axios from "axios";
import Toast from "react-bootstrap/Toast";
import { Dropdown } from "react-bootstrap";
import ToastContainer from "react-bootstrap/ToastContainer";


function Complaints({ id, csrfToken }) {
  const [open, setOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const formRef = useRef(null);

  const CSRF_TOKEN = csrfToken;

  const sendComplaints = () => {
    const form = formRef.current;
    if (form) {
      const formData = new FormData(form);
      const complainType = formData.entries().next().value[1];
      const data = {
        command: "complain",
        content_type: "proposals",
        object_id: id,
        complaint_type: complainType,
      };

      const payload = new URLSearchParams(data).toString();
      console.log("PAYLOAD COMPLAIN PROPOSALS", payload);
      async function sendData(payload) {
        try {// No siempre se tiene que enviar a "."
          const response = await axios.post(".", payload, {
            headers: {
              "X-CSRFToken": CSRF_TOKEN,
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
              "X-Requested-With": "XMLHttpRequest",
            },
            withCredentials: true,
          });
          setShowToast(true);
          setIsSuccess(true);
          setIsError(false);
          setOpen(false);
          // `response.data` contiene la respuesta del servidor en formato JSON
          return response.data;
        } catch (error) {
          console.error("Error al enviar los datos:", error);
          setShowToast(true);
          setIsError(true);
          setIsSuccess(false);
          setOpen(false);
          throw error;
        }
      }
      sendData(payload);
    }
  };

  return (
    <>
      <Dropdown
        className="d-inline mx-2"
        autoClose="outside"
        show={open}
        onToggle={(next) => setOpen(next)}
      >
        <Dropdown.Toggle
          id="complaints"
          className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
        >
          Denunciar <i className="fa fa-warning"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <form
            id={`complaints_form_post_${id}`}
            className="px-4 py-3"
            ref={formRef}
          >
            <div className="form-check text-nowrap mb-2">
              <input
                className="form-check-input"
                type="radio"
                id={`complaints-react-${id}_1`}
                name={`complaints-react-${id}`}
                value="odio"
              />
              <label
                className="form-check-label"
                htmlFor={`complaints-react-${id}_1`}
              >
                Delito de odio
              </label>
            </div>
            <div className="form-check text-nowrap mb-2">
              <input
                className="form-check-input"
                type="radio"
                id={`complaints-react-${id}_2`}
                name={`complaints-react-${id}`}
                value="falso"
              />
              <label
                className="form-check-label"
                htmlFor={`complaints-react-${id}_2`}
              >
                Informacion falsa
              </label>
            </div>
            <div className="form-check text-nowrap mb-2">
              <input
                className="form-check-input"
                type="radio"
                id={`complaints-react-${id}_3`}
                name={`complaints-react-${id}`}
                value="spam"
              />
              <label
                className="form-check-label"
                htmlFor={`complaints-react-${id}_3`}
              >
                Spam
              </label>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center mt-2">
              <button
                className="complaints-react-submit-btn w-100 btn btn-sm btn-outline-primary"
                type="button"
                onClick={sendComplaints}
              >
                Enviar
              </button>
            </div>
          </form>
        </Dropdown.Menu>
      </Dropdown>
      <ToastContainer
        className="p-3"
        position="bottom-end"
        style={{ zIndex: "3080", position: "fixed" }}
      >
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          bg={isError ? "danger" : "success"}
          autohide
        >
          <Toast.Body className="d-flex text-white border-0 rounded-1 align-items-center">
            {isError && "Error al enviar la denuncia"}
            {isSuccess && "El comentario ha sido denunciado con éxito."}
            <button
              type="button"
              aria-label="Close"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
            ></button>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default Complaints;
